const BASE_URL = 'http://localhost:5001/api';

let adminToken = localStorage.getItem('admin_token') || null;

export const setToken = (token) => {
  adminToken = token;
  if (token) {
    localStorage.setItem('admin_token', token);
  } else {
    localStorage.removeItem('admin_token');
  }
};

export const getToken = () => adminToken;

export const isLoggedIn = () => !!adminToken;

export const logout = () => {
  setToken(null);
};

const request = async (endpoint, options = {}) => {
  const url = `${BASE_URL}${endpoint}`;
  
  const headers = {
    'Content-Type': 'application/json',
    ...(adminToken ? { 'Authorization': `Bearer ${adminToken}` } : {}),
    ...options.headers,
  };

  const config = {
    ...options,
    headers,
  };

  try {
    const res = await fetch(url, config);
    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (e) {
      data = { message: text };
    }

    if (!res.ok) {
      throw new Error(data.message || data.msg || `Request failed with status ${res.status}`);
    }

    return data;
  } catch (error) {
    console.error(`API Error in ${endpoint}:`, error.message);
    throw error;
  }
};

export const loginAdmin = async (email, password) => {
  const data = await request('/auth/admin/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
  if (data.success && data.data && data.data.token) {
    setToken(data.data.token);
  }
  return data;
};

export const getDashboardStats = () => request('/admin/dashboard');

export const getAdminSettings = () => request('/admin/settings');

export const uploadCityVideo = async (payload) => {
  if (payload instanceof FormData) {
    const url = `${BASE_URL}/admin/settings/video`;
    const headers = {
      ...(adminToken ? { 'Authorization': `Bearer ${adminToken}` } : {}),
    };
    const res = await fetch(url, { method: 'POST', headers, body: payload });
    const data = await res.json();
    if (!res.ok || !data.success) {
      throw new Error(data.message || data.msg || 'Video upload failed');
    }
    return data;
  }
  return request('/admin/settings/video', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getCaptains = (status = '') => {
  const query = status ? `?status=${status}` : '';
  return request(`/admin/captains${query}`);
};

export const approveCaptain = (id) => request(`/admin/captains/${id}/approve`, { method: 'PUT' });

export const rejectCaptain = (id, rejectionReason) => request(`/admin/captains/${id}/reject`, {
  method: 'PUT',
  body: JSON.stringify({ rejectionReason })
});

export const getPendingArtists = () => request('/artist/pending');

export const approveArtistProfile = (id) => request(`/artist/${id}/verify`, {
  method: 'PUT',
  body: JSON.stringify({ status: 'approved' })
});

export const rejectArtistProfile = (id, rejectionReason) => request(`/artist/${id}/verify`, {
  method: 'PUT',
  body: JSON.stringify({ status: 'rejected', notes: rejectionReason })
});

export const blockCaptain = (id) => request(`/admin/captains/${id}/block`, { method: 'PUT' });
export const unblockCaptain = (id) => request(`/admin/captains/${id}/unblock`, { method: 'PUT' });

export const unlockCaptainModules = (id, moduleNames, durationDays) => request(`/admin/captains/${id}/unlock-module`, {
  method: 'PUT',
  body: JSON.stringify({ moduleNames, durationDays })
});

export const lockCaptainModule = (id, moduleName) => request(`/admin/captains/${id}/lock-module`, {
  method: 'PUT',
  body: JSON.stringify({ moduleName })
});

export const createRoom = (payload) => request('/rooms', {
  method: 'POST',
  body: JSON.stringify(payload)
});

export const getRooms = (status = '') => {
  const query = status ? `?status=${status}` : '';
  return request(`/admin/rooms${query}`);
};

export const approveRoom = (id) => request(`/admin/rooms/${id}/approve`, { method: 'PUT' });

export const rejectRoom = (id, rejectionReason) => request(`/admin/rooms/${id}/reject`, {
  method: 'PUT',
  body: JSON.stringify({ rejectionReason })
});

export const deleteRoom = (id) => request(`/admin/rooms/${id}`, { method: 'DELETE' });

export const getUsers = () => request('/admin/users');
export const blockUser = (id) => request(`/admin/users/${id}/block`, { method: 'PUT' });
export const unblockUser = (id) => request(`/admin/users/${id}/unblock`, { method: 'PUT' });

export const getBookings = () => request('/admin/bookings');
export const getPayments = () => request('/admin/payments');
export const getReports = () => request('/admin/reports');

export const resolveReport = (id, adminAction) => request(`/admin/reports/${id}/resolve`, {
  method: 'PUT',
  body: JSON.stringify({ adminAction })
});

// Ground booking slots retrieval (public endpoint)
export const getRoomSlots = (roomId, date = '') => {
  const query = date ? `?date=${date}` : '';
  return request(`/rooms/${roomId}/slots${query}`);
};

export const updateBookingStatus = (id, bookingStatus, paymentStatus) => request(`/admin/bookings/${id}`, {
  method: 'PUT',
  body: JSON.stringify({ bookingStatus, paymentStatus })
});

export const createTrack = async (payload) => {
  if (payload instanceof FormData) {
    const url = `${BASE_URL}/tracks`;
    const headers = {
      ...(adminToken ? { 'Authorization': `Bearer ${adminToken}` } : {}),
    };
    try {
      console.log('📡 Sending FormData track payload to:', url);
      const res = await fetch(url, { method: 'POST', headers, body: payload });
      const data = await res.json();
      if (!res.ok || !data.success) {
        console.error('❌ Track Upload API Error:', data);
        throw new Error(data.message || data.msg || `Upload failed with HTTP ${res.status}`);
      }
      console.log('✅ Track Upload API Success:', data);
      return data;
    } catch (err) {
      console.error('❌ Track Upload Exception:', err);
      throw err;
    }
  }
  return request('/tracks', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

export const getTracks = () => request('/tracks');
export const deleteTrack = (id) => request(`/tracks/${id}`, { method: 'DELETE' });
